import { takeLatest, put, call } from "redux-saga/effects";
import type { ISaga, DepositRatesData } from "../types";
import {
  fetchPesoSavingRate,
  fetchPesoCheckingRate,
  fetchForeignCurrencySavingsRate,
  fetchTierredDepositRates,
} from "network/services/rates";
import {
  fetchDepositRatesSuccess,
  fetchDepositRatesError,
} from "../actionCreators";

function* processFetchDepositRates(): ISaga {
  try {
    const { data: pesoSavingsRate } = yield call(fetchPesoSavingRate);
    const { data: pesoCheckingRate } = yield call(fetchPesoCheckingRate);
    const { data: foreignCurrencySavingsRate } = yield call(
      fetchForeignCurrencySavingsRate
    );
    const { data: tierredDepositRates } = yield call(fetchTierredDepositRates);

    let payload: DepositRatesData = {
      pesoSavingsRate,
      pesoCheckingRate,
      foreignCurrencySavingsRate,
      tierredDepositRates,
    };

    yield put(fetchDepositRatesSuccess(payload));
  } catch (e) {
    console.log("FETCHING DEPOSIT RATES ERROR", e);
    yield put(fetchDepositRatesError());
  }
}

export default function* watcher() {
  yield takeLatest("REQUEST_DEPOSIT_RATES_DATA", processFetchDepositRates);
}
